import { render, staticRenderFns } from "./configurationList.vue?vue&type=template&id=587e0b73&scoped=true&"
import script from "./configurationList.vue?vue&type=script&lang=js&"
export * from "./configurationList.vue?vue&type=script&lang=js&"
import style0 from "./configurationList.vue?vue&type=style&index=0&id=587e0b73&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587e0b73",
  null
  
)

export default component.exports